// Weapon type, either melee or ranged
export var WeaponType;
(function (WeaponType) {
    WeaponType[WeaponType["Melee"] = 0] = "Melee";
    WeaponType[WeaponType["Ranged"] = 1] = "Ranged";
    WeaponType[WeaponType["Unknown"] = 99] = "Unknown";
})(WeaponType || (WeaponType = {}));
export var WeaponSelectionPer;
(function (WeaponSelectionPer) {
    // the weapon selection is per model (every model can have n)
    WeaponSelectionPer["Model"] = "Model";
    // per unit (every MIN unit can have n)
    WeaponSelectionPer["Unit"] = "Unit";
})(WeaponSelectionPer || (WeaponSelectionPer = {}));
